// ============================================================================
// FRENCH TRANSLATIONS - BIBLE TREASURES (TRESORS)
// ============================================================================
// Trésors spirituels et perles de sagesse biblique

export const bibleTreasures = [
  {
    type: "perle_sagesse",
    content: "Celui qui marche avec les sages devient sage, mais celui qui se plaît avec les insensés s'en trouve mal",
    reference: "Proverbes 13:20",
    category: "sagesse",
    strongNumbers: {
      "sages": "H2450", // חכם (chakam) = sage, intelligent
      "marche": "H1980" // הלך (halak) = marcher, vivre
    },
    reflection: "L'importance de bien choisir ses compagnons et mentors"
  },
  {
    type: "tresor_divine",
    content: "L'Éternel est près de ceux qui ont le cœur brisé, et il sauve ceux qui ont l'esprit dans l'abattement",
    reference: "Psaume 34:18",
    category: "consolation",
    strongNumbers: {
      "près": "H7138", // קרוב (qarob) = proche, près
      "cœur_brisé": "H7665" // שבר (shabar) = briser, détruire
    },
    reflection: "Dieu est particulièrement proche de ceux qui souffrent"
  },
  {
    type: "promesse_divine",
    content: "Car mes pensées ne sont pas vos pensées, et vos voies ne sont pas mes voies, dit l'Éternel",
    reference: "Ésaïe 55:8",
    category: "mystère_divin",
    strongNumbers: {
      "pensées": "H4284", // מחשבה (machashebah) = pensée, projet
      "voies": "H1870" // דרך (derek) = chemin, voie
    },
    reflection: "La sagesse divine dépasse notre compréhension humaine"
  },
  {
    type: "encouragement",
    content: "Fortifiez-vous et ayez du courage ! Ne craignez point et ne vous effrayez point, car l'Éternel, ton Dieu, est avec toi",
    reference: "Josué 1:9",
    category: "courage",
    strongNumbers: {
      "fortifiez": "H2388", // חזק (chazaq) = être fort, tenir ferme
      "courage": "H553" // אמץ (amats) = être courageux
    },
    reflection: "Le courage vient de la présence constante de Dieu"
  },
  {
    type: "mystère_foi",
    content: "Or la foi est une ferme assurance des choses qu'on espère, une démonstration de celles qu'on ne voit pas",
    reference: "Hébreux 11:1",
    category: "foi",
    strongNumbers: {
      "foi": "G4102", // πίστις (pistis) = foi, confiance
      "assurance": "G5287" // ὑπόστασις (hypostasis) = substance, assurance
    },
    reflection: "La foi transcende le visible et rend réel l'invisible"
  },
  {
    type: "revelation",
    content: "Mais celui qui boira de l'eau que je lui donnerai n'aura jamais soif",
    reference: "Jean 4:14",
    category: "vie_spirituelle",
    strongNumbers: {
      "eau": "G5204", // ὕδωρ (hydor) = eau
      "soif": "G1372" // διψάω (dipsao) = avoir soif
    },
    reflection: "Jésus offre une satisfaction spirituelle éternelle"
  },
  {
    type: "heritage_divin",
    content: "Or, si nous sommes enfants, nous sommes aussi héritiers : héritiers de Dieu, et cohéritiers de Christ",
    reference: "Romains 8:17",
    category: "identité",
    strongNumbers: {
      "héritiers": "G2818", // κληρονόμος (kleronomos) = héritier
      "enfants": "G5043" // τέκνον (teknon) = enfant, descendant
    },
    reflection: "Notre identité divine comme enfants et héritiers de Dieu"
  }
];

export default bibleTreasures;